import { STATSIG_DEFAULT_VALUE } from "shared-lib/constants";
import * as gtag from "shared-lib/gtag";
import { TRACKING_CATEGORIES } from "shared-lib/helpers/statsigFunctions";

export function sendExperimentGtagEvent(
  experimentName: string,
  experimentValue: string,
): boolean {
  if (experimentValue === STATSIG_DEFAULT_VALUE) {
    return false;
  }

  gtag.event({
    action: experimentName,
    category: TRACKING_CATEGORIES.view,
    label: experimentValue,
  });

  return true;
}
